import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { data } from "src/app/audit-trail/application/data";
import { AuditTrailService } from "src/app/audit-trail/audit-trail.service";
import { LotteryFormResponse } from "src/app/model/LotteryFormResponse";
import { ExportImportService } from "src/app/services/export-import.service";
import { PublishLettersService } from "src/app/services/publish-letters.service";
import { ReportService } from "src/app/services/report.service";

@Component({
  selector: "app-secure-download-project-tenement",
  templateUrl: "./download-project-tenement.component.html",
  styleUrls: ["./download-project-tenement.component.scss"],
})
export class DownloadProjectTenementComponent implements OnInit {
  [x: string]: any;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  projectTenementDt: { [key: number]: string };
  isSubmitDisabled: boolean = false;
  downloadedBatches: string[] = [];
  boards: { [key: number]: string };
  board: any;
  projectId: any;
  lottery: any;
  startDate: any;
  endDate: any;

  constructor(
    private router: Router,
    private exportImportService: ExportImportService,
    private reportService: ReportService,
    private publishLetterService: PublishLettersService,
    private auditTrailService: AuditTrailService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.reportService.initQueryExecutorForm().subscribe((data) => {
      this.boards = data.boards;
      console.log(data);
    });

    this.publishLetterService.publishDocumentsInitForm().subscribe(
      (data: any) => {
        this.isLoading = false;
        this.lotteryList = data.lotteryList;
      },
      (error) => {
        this.isLoading = false;
        this.publishLetterService.errorToast(
          error.errorMessage || error.error.errorMessage
        );
      }
    );
  }

  refresh() {
    this.loadData();
  }

  async successToast() {
    await this._snackBar.open(
      " Project Tenement Exported Successfully",
      "Close",
      {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  onBoardChange(event) {
    this.projectTenementDt = null;
    this.board = event.value;
    this.auditTrailService
      .changeBoard(this.board)
      .subscribe((data: LotteryFormResponse) => {
        this.projectTenementDt = data.projectTenementDt;
      });
  }

  onProjectSelect(e) {
    this.projectId = e.value;
  }

  downloadProjectmaster() {
    this.isLoading = true;
    console.log(this.board);
    this.auditTrailService.downloadProjectTenement(this.board).subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.data = data;
          this.downloadCsv(this.data);
          this.successToast();
        } else {
          this.exportImportService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.exportImportService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadProjectImages() {
    this.isLoading = true;
    this.auditTrailService.downloadProjectImages(this.projectId).subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          this.data = data;
          this.downloadFile(this.data.base64File, this.data.fileName);

          this.successToast();
        } else {
          this.exportImportService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.exportImportService.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  downloadCsv(data: any) {
    console.log(">>>>>>>>>>>>>>>>>>>>", data);
    const columnHeaders = [
      "Board Code",
      "Project Code",
      "Project Address",
      "Taluka",
      "Maharara No",
      "Latitude",
      "Longitude",
      "Property Type",
      "CTS No",
      "Building No",
      "Wing",
      "Floor",
      "Flat No",
      "Builtup Area",
      "Carpet Area",
      "Cost",
      "Amenities",
      "Maintenance Cost",
      "Blocked",
      "Remarks",
    ];
    this.exportCsv(data.tenementList, "Project_Tenement", columnHeaders);
  }

  exportCsv(data: any[], fileName: string, columnHeaders: string[]) {
    let csvContent = columnHeaders.join(",") + "\n";
    csvContent += data.map((row) => Object.values(row).join(",")).join("\n");

    const encodedUri = encodeURI("data:text/csv;charset=utf-8," + csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName + ".csv");
    document.body.appendChild(link);
    link.click();
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
}
